export default __webpack_public_path__ + "static/media/sm_jelly_fish.331ef4ac.gif";